export const ACCESS_TOKEN = "accessToken";

/**
 * While a SystemOwner simulates a business, their own token waits here — with
 * the business's name for the banner — until the simulation ends. JSON:
 * `{ originalToken, businessName, ownerEmail }`.
 */
export const IMPERSONATION = "impersonation";
